import axiosInstance from "../../utils/setupAxios";

export const submitContactMessage = async (data: {
  phone: string;
  email: string;
  subject: string;
  message: string;
}) => {
  return await axiosInstance.post("/contact", data);
};
